'use client';
import { createContext, type ReactNode } from 'react';

import { useCustomerStore } from '@/stores';
import type { CustomerDataWithDocument } from '@/stores/customerStore';

type AuthContextType = {
  isAuthenticated: boolean;
  customerData: CustomerDataWithDocument | null;
};

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  customerData: null,
});

type AuthProviderProps = {
  children: ReactNode;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const customerData = useCustomerStore((state) => state.customerData);
  const isAuthenticated = !!(
    customerData &&
    customerData.name &&
    customerData.document &&
    customerData.phone
  );

  const value = {
    isAuthenticated,
    customerData,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
